
import Vue from "vue";

export default Vue.extend({
	props: {
		duration: {
			type: [Number, String],
			default: .15
		},
	},
	computed: {
		transitionCssRule():string {
			return `height ${this.duration}s ease`;
		},
		durationMiliseconds():number {
			return parseFloat(this.duration + "") * 1000;
		}
	},
	methods: {
		transitionBeforeEnter(el:HTMLElement){
			el.style.transition = this.transitionCssRule;
			el.style.height = "auto";
			el.style.boxSizing = "border-box";
		},
		transitionEnter(el: HTMLElement, done: Function) {
			let height = el.getBoundingClientRect().height;
			el.style.height = "0px";
			// is required to properly rerender the component and trigger the animation
			// requestAnimationFrame doesn't work reliably
			el.getBoundingClientRect();
			el.style.height = height + "px";
			setTimeout(done, this.durationMiliseconds);
		},
		transitionAfterEnter(el:HTMLElement) {
			el.style.height = "";
		},
		transitionBeforeLeave(el:HTMLElement) {
			el.style.transition = this.transitionCssRule;
			el.style.boxSizing = "border-box";
			let height = el.getBoundingClientRect().height;
			el.style.height = height + "px";
			// is required to properly rerender the component and trigger the animation
			// requestAnimationFrame doesn't work reliably
			el.getBoundingClientRect();
			el.style.height = `0px`;
		},
		transitionLeave(el:HTMLElement, done:Function) {
			el.style.height = "0px";
			setTimeout(done, this.durationMiliseconds);
		},
	},
});
